export default "__VITE_ASSET__CSd30KTf__"